// PostHog initialization for the React frontend.
// Env-gated: when REACT_APP_POSTHOG_KEY is missing, init() becomes a no-op.
//
// Coverage:
//   - autocapture (clicks, form submits, page views)
//   - identified users (via ph.identify after login)
//   - custom events (call track("event_name", props))
//
// PII: session recording OFF by default; email is opt-in via identify().

import posthog from "posthog-js";

const key = process.env.REACT_APP_POSTHOG_KEY;
const host = process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";

let initialized = false;

if (key) {
  try {
    posthog.init(key, {
      api_host: host,
      person_profiles: "identified_only",
      capture_pageview: true,
      capture_pageleave: true,
      disable_session_recording: true,
      loaded: (ph) => {
        try {
          ph.register({ app: "classmate", release: process.env.REACT_APP_SENTRY_RELEASE || "dev" });
        } catch (_) {}
      },
    });
    initialized = true;
    // eslint-disable-next-line no-console
    console.info("[PostHog] initialized host=" + host);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[PostHog] init failed:", e);
  }
}

export const ph = posthog;
export const posthogInitialized = () => initialized;

// Thin wrappers so the rest of the app doesn't import the SDK directly
export function phIdentify(userId, props = {}) {
  if (!initialized || !userId) return;
  try {
    posthog.identify(userId, props);
  } catch (_) {}
}

export function phReset() {
  if (!initialized) return;
  try {
    posthog.reset();
  } catch (_) {}
}

export function phTrack(event, props = {}) {
  if (!initialized) return;
  try {
    posthog.capture(event, props);
  } catch (_) {}
}
